import React, { FC, useContext, useEffect, useMemo, useState } from 'react';
import dogHead from 'assets/images/dog_head.svg';
import { useNavigate } from 'react-router-dom';
import SearchPanel from './SearchPanel';
import { useLocation } from "react-router";
import DogListSortSelect from './DogListSortSelect';
import { DataContext } from 'hooks/HeaderContext';
import { Button, Alert } from 'reactstrap';
import { FILTER_KEY, FILTER_TYPE } from 'types/Dog';
import { Typeahead } from 'react-bootstrap-typeahead';
import { capitalizeEveryWord } from 'helpers/capitalizeEveryWord';
import { Option } from 'types/Option';

const HeaderPanel: FC = ({ }) => {

    const {
        filteredDogsList: dogList,
        selectedDogIndex,
        setSelectedDogIndex,
        customView,
        institutionSearchText,
        updateInstitutionSearchText,
        validFilters,
        dogListError,
        loading,
    } = useContext(DataContext);

    const navigate = useNavigate();
    const location = useLocation();
    const [showUserLocationDiv, setShowUserLocationDiv] = useState(false);
    const [currentPage, setCurrentPage] = useState<string>('');
    const [showInstitutionSearchPanel, setShowInstitutionSearchPanel] = useState(false);

    useEffect(() => {
        setShowUserLocationDiv(false);
        setShowInstitutionSearchPanel(false);
        setCurrentPage(location.pathname);
    }, [location.pathname]);

    const toggleSearchPanel = () => {
        setShowUserLocationDiv(e => !e);
    }

    const selectNextDog = () => {
        let index = (selectedDogIndex === dogList.length - 1) ? 0 : (selectedDogIndex + 1);
        setSelectedDogIndex(index);
        navigate('/dog/detail/' + dogList[index].id);
    }

    const selectPreviousDog = () => {
        let index = (selectedDogIndex === 0) ? dogList.length - 1 : (selectedDogIndex - 1);
        setSelectedDogIndex(index);
        navigate('/dog/detail/' + dogList[index].id);
    }

    const partneringSheltersOptions: Option[] = useMemo(() => {
        if (!Object.values(validFilters)) return null;
        else {
            const institutions = validFilters[FILTER_KEY[FILTER_TYPE.INSTITUTION]]?.map(i => { return { ...i, label: capitalizeEveryWord(i.description) } });
            return institutions?.concat(validFilters[FILTER_KEY[FILTER_TYPE.SHELTER]]) || [];
        }
    }, [validFilters])

    return (
        <>
            <div className="text-light py-1 " id="rangeDiv">
                <div className="container-lg h-100 d-flex align-items-center justify-content-between py-2">
                    {currentPage && currentPage !== '/' &&
                        <>
                            <button type="button" className="btn btn-link text-light text-decoration-none"
                                onClick={() => navigate('/')}
                            >
                                <i className="bi bi-chevron-left me-2"></i>
                                Available Dogs
                            </button>
                        </>
                    }
                    {currentPage && currentPage.startsWith('/dog/detail') &&
                        <div>
                            <button type="button" className="btn btn-link text-light text-decoration-none"
                                onClick={() => selectPreviousDog()}>
                                <i className="bi bi-caret-left-fill me-2"></i>
                            </button>
                            Dog
                            <button type="button" className="btn btn-link text-light text-decoration-none"
                                onClick={() => selectNextDog()}>
                                <i className="bi bi-caret-right-fill ms-2"></i>
                            </button>
                        </div>
                    }
                    {!dogListError && currentPage && currentPage === '/' &&
                        <>
                            <div className="h6 mb-0 d-md-flex align-items-center w-100 me-3 ">
                                <div className="d-flex align-items-center">
                                    <img src={dogHead} className="me-3" />
                                    <div className='d-lg-flex align-items-center '>
                                        {loading ? <>Loading Dogs ...</> : dogList &&
                                            <>
                                                <div className='me-2'>
                                                    <span className="dogNumber">{dogList.length + ' ' + (dogList.length === 1 ? 'Dog' : 'Dogs')}</span>
                                                </div>
                                                <>
                                                    {!customView && 'within Missouri'}
                                                    {customView &&
                                                        <>
                                                            {'within ' + customView.range + ' miles of ' + customView?.location?.cityZip}
                                                        </>
                                                    }
                                                </>
                                                <div className='d-none d-lg-block ms-2'>
                                                    <a
                                                        role='button'
                                                        className="btn btn-primary d-flex align-items-center px-3"
                                                        onClick={() => toggleSearchPanel()}
                                                        tabIndex={0}

                                                    >
                                                        <i className="bi bi-geo-alt-fill fs-5"></i>
                                                    </a>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                                {/* {showSaveSearchBtn &&
                                    <div className='d-flex mx-auto mobile-save-search-btn'>
                                        <button type="button" className="btn btn-primary rounded-pill fw-bold px-5 py-2 mx-auto save-search-btn"
                                            onClick={_ => saveFilters()}
                                        >
                                            Save Search
                                        </button>
                                    </div>
                                } */}
                            </div>
                        </>
                    }

                    {currentPage === '/' &&
                        <div className="d-flex">
                            <div className='d-none d-lg-block'>
                                <DogListSortSelect />
                            </div>
                            <div className='d-lg-none'>
                                <button type="button"
                                    className="btn btn-primary d-flex align-items-center"
                                    onClick={() => toggleSearchPanel()}

                                >
                                    <i className="bi bi-geo-alt-fill"></i>
                                </button>
                            </div>
                        </div>
                    }
                    {currentPage === '/adopt' &&
                        <div className="col-lg-4">
                            <div className='d-none d-md-block' style={{ minWidth: '280px' }}>
                                <div className='position-relative mx-auto'>
                                    <Typeahead
                                        options={partneringSheltersOptions}
                                        placeholder='Search Instition/Shelter ...'
                                        id='partnerships-typeahead'
                                        multiple={false}
                                        minLength={1}
                                        clearButton={true}
                                        selected={(institutionSearchText && [institutionSearchText]) || []}
                                        selectHint={(shouldSelect, event) => (
                                            event.key === "Enter" || shouldSelect
                                        )}
                                        onChange={loc => updateInstitutionSearchText(loc[0])}

                                    />
                                    <i className='bi bi-search font-primary position-absolute'
                                        style={{ left: '10px', top: '11px', backgroundColor: 'white' }}
                                    ></i>
                                </div>
                            </div>
                            <div className='d-md-none'>
                                <Button
                                    color="primary"
                                    onClick={() => setShowInstitutionSearchPanel(e => !e)}

                                >
                                    <i className='bi bi-search'></i>
                                </Button>
                            </div>
                        </div>
                    }
                </div>
            </div >
            <SearchPanel isOpen={showUserLocationDiv} toggleSearchPanel={toggleSearchPanel} />
            <div className='d-md-none'>
                <Alert
                    isOpen={showInstitutionSearchPanel}
                    color='light'
                    className="py-2"
                >
                    <div className='w-100 me-3'>
                        <div className='position-relative mx-auto'>
                            <Typeahead
                                options={partneringSheltersOptions}
                                placeholder='Search Instition/Shelter ...'
                                id='partnerships-typeahead'
                                multiple={false}
                                minLength={1}
                                clearButton={true}
                                autoFocus
                                selected={(institutionSearchText && [institutionSearchText]) || []}
                                selectHint={(shouldSelect, event) => (
                                    event.key === "Enter" || shouldSelect
                                )}
                                onChange={loc => updateInstitutionSearchText(loc[0])}
                            />
                            <i className='bi bi-search font-primary position-absolute'
                                style={{ left: '10px', top: '11px', backgroundColor: 'white' }}
                            ></i>
                        </div>

                    </div>
                </Alert>

            </div>
        </>

    )
}

export default HeaderPanel;




















